import Icons from '../../assets/icons/index.js';
import ProjectColor from '../../js/projectColor.js';
import {
  AdminprofileImage,
  Navbar,
  AnimateSpin,
  Pagination,
  MainHeading,
  ProjectTrackingCom,
  Text,
} from '../../components/index';
import statusFunction from './index.function.js';
import { fontSizes } from '../../constants/constants.js';
const Status = () => {
  const {
    isLoading,
    projectData,
    handleProjectClick,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
    TextWeight,
  } = statusFunction();
  return (
    <div className='flex'>
      <Navbar />
      <div className='flex-1 flex flex-col h-screen'>
        <div className='px-4 lg:px-12 pt-10'>
          <AdminprofileImage />
          <MainHeading
            Icon={Icons.StatusTrackingIcon}
            heading={'Status Tracking'}
            paragraph={
              "Stay updated on your project's progress by checking its details below to monitor progress in real-time."
            }
          />
        </div>
        <div className='flex-1 overflow-y-auto w-full h-full hide-scrollbar px-4 lg:px-7 2xl:px-12'>
          {isLoading ? (
            <AnimateSpin />
          ) : projectData?.data?.data.length === 0 ? (
            <Text
              text={'No projects found'}
              size={fontSizes.h18}
              weight={TextWeight.Raleway_SemiBold}
              color='text-black'
              isTruncate={false}
            />
          ) : (
            <div className='grid grid-cols-1 gap-6 sm:gap-5 lg:gap-6 lg:grid-cols-2 xl:grid-cols-3 py-2'>
              {projectData?.data?.data.map((val, index) => (
                <div key={index} onClick={() => handleProjectClick(val)}>
                  <ProjectTrackingCom
                    ProjectName={val?.name}
                    IconicHomes={val?.IconicHomes}
                    projectDate={new Date(val?.createdAt).toLocaleDateString()}
                    // projectHour={val?.quantityReportStatus === 'IN_PROGRESS' ? '1 Hour' : ''}
                    projectStatus={val?.quantityReportStatus}
                    projectColor={
                      ProjectColor[index % ProjectColor.length].color
                    }
                    StatusCheckIcons={Icons?.statusCheckIcon}
                    cursorClassName={
                      val?.quantityReportStatus === 'COMPLETED'
                        ? 'cursor-pointer'
                        : 'cursor-default'
                    }
                    quantityStatus={val?.quantityReportStatus}
                    materialReportStatus={val?.materialReportStatus}
                    costingReportStatus={val?.costingReportStatus}
                    isCostingReportVerified={val?.isCostingReportVerified}
                    isMaterialReportVerified={val?.isMaterialReportVerified}
                    isQuantityReportVerified={val?.isQuantityReportVerified}
                    serviceName={val?.service?.name}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className='w-full flex justify-center px-4 lg:px-12 pb-4 lg:pb-10 pt-2'>
          {totalItems > 6 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Status;
